import {DocumentPermissionsData, IDocumentData} from "@buildwithflux/models";

/**
 * @deprecated If you know all the role data, you're better off with `userPermissionsToPermissionsMap()`. And in many
 *   other cases you'd want to use Redux to update the role data. At least make sure you check `setRoleData()` for how
 *   you'd need to update the user_access_list and has_anon_access properties after calling this function
 */
export function setRole(documentData: IDocumentData, role: DocumentPermissionsData) {
    role.updated_at = new Date().getTime();
    return (documentData.roles[role.user_uid] = role);
}
